import React from 'react'

import PropTypes from 'prop-types'

const TitleUserArea = ({title}) => <h1 className="mt-TitleUserArea">{title}</h1>

TitleUserArea.displayName = 'TitleUserArea'

TitleUserArea.propTypes = {
  title: PropTypes.string.isRequired
}

export default TitleUserArea
